import { toRem } from "shared/helpers";
import styled from "styled-components";

export const Tabs = styled.div`
  display: grid;
  justify-content: space-evenly;
  grid-auto-flow: column;
  grid-auto-columns: ${toRem(73)};
  grid-auto-rows: ${toRem(20)};
  gap: ${toRem(8)};
  padding: 0px ${toRem(16)} ${toRem(12)} ${toRem(16)};
`;

export const Tab = styled.div`
  text-align: center;
  font-weight: 500;
  line-height: ${toRem(20)};
  background: transparent;
  border: none;
  font-size: ${toRem(16)};
`;
